export const calculateTax = (amount: number): number => {
  return amount / 1.12;
};
export const calculateNetAmount = (vatAmount: number): number => {
  const tax = calculateTax(vatAmount);

  return tax * 0.01;
};
